import { render, staticRenderFns } from "./SuperBook.vue?vue&type=template&id=57bb1cdb&scoped=true"
import script from "./SuperBook.vue?vue&type=script&lang=js"
export * from "./SuperBook.vue?vue&type=script&lang=js"
import style0 from "./SuperBook.vue?vue&type=style&index=0&id=57bb1cdb&prod&lang=sass&scoped=true"
import style1 from "./SuperBook.vue?vue&type=style&index=1&id=57bb1cdb&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb1cdb",
  null
  
)

export default component.exports